export const SEND_QR_MAIL: string = "SEND_QR_MAIL";